module.exports = __webpack_public_path__ + "img/user-video.07a8991b.png";